import { MessageThreadType, UserStatusType } from "gql/graphql";

export enum WebSocketMessageType {
  PING = "PING",
  PONG = "PONG",
  NEW_MESSAGE = "NEW_MESSAGE",
  MESSAGE_THREAD = "MESSAGE_THREAD",
  MESSAGE = "MESSAGE",
  USER_ATTRIBUTE_CATEGORY = "USER_ATTRIBUTE_CATEGORY",
  USER_ATTRIBUTE = "USER_ATTRIBUTE",
  TAG_CATEGORY = "TAG_CATEGORY",
  TAG = "TAG",
  DISTRIBUTION_GROUP = "DISTRIBUTION_GROUP",
  USER = "USER",
  ORGANIZATION = "ORGANIZATION",
  USERS_ONLINE = "USERS_ONLINE",
  TYPING = "TYPING",
  PUSH_NOTIFICATION = "PUSH_NOTIFICATION",
  MESSAGE_SEEN = "MESSAGE_SEEN",
  JOB = "JOB",
  CALL = "CALL",
  INCOMING_CALL = "INCOMING_CALL",
  CALL_ENDED = "CALL_ENDED",
  REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION",
}

export enum WebSocketNotificationType {
  ALERT = "ALERT",
  DATA = "DATA",
  BADGE = "BADGE",
}

export interface IWebSocketPayloadBase {
  type: WebSocketMessageType;
  notificationType: WebSocketNotificationType;
}

export interface IWebSocketPayloadNewMessage extends IWebSocketPayloadBase {
  id: string;
  parentId: string;
}

export interface IWebSocketPayloadMessageThread extends IWebSocketPayloadBase {
  id?: string;
  idList?: string[];
}

export interface IWebSocketPayloadMessage extends IWebSocketPayloadBase {
  id?: string;
  idList?: string[];
}

export interface IWebSocketPayloadUserAttributeCategory
  extends IWebSocketPayloadBase {
  id: string;
}

export interface IWebSocketPayloadUserAttribute extends IWebSocketPayloadBase {
  id?: string;
  idList?: string[];
}

export interface IWebSocketPayloadTagCategory extends IWebSocketPayloadBase {
  id: string;
}

export interface IWebSocketPayloadTag extends IWebSocketPayloadBase {
  id?: string;
  idList?: string[];
}

export interface IWebSocketPayloadDistributionGroup
  extends IWebSocketPayloadBase {
  id?: string;
  idList?: string[];
}

export interface IWebSocketPayloadUser extends IWebSocketPayloadBase {
  id?: string;
  idList?: string[];
}

export interface IWebSocketPayloadUsersOnline extends IWebSocketPayloadBase {
  userIds: string[];
  statusType: UserStatusType;
}

export interface IWebSocketPayloadTyping extends IWebSocketPayloadBase {
  messageThreadId: string;
  userId: string;
  messageThreadType: MessageThreadType;
}

export interface IWebSocketPayloadAlert extends IWebSocketPayloadBase {
  id: string;
  createTime: string;
  createdUserId: string;
  createdUserName: string;
  inboxNotSeenCount: number;
  messageBody: string;
  messageThreadId: string;
  messageTitle: string;
  messageThreadType: MessageThreadType;
  g?: string; //gzipped notification
}

export interface IWebSocketPayloadMessageSeen extends IWebSocketPayloadBase {
  messageThreadId: string;
  messageId: string;
  seenUserIdList: string[];
}

export interface IWebSocketPayloadCall extends IWebSocketPayloadBase {
  id: string;
}

/** Sent when a call ends, times out, or was answered/declined by this user elsewhere. */
export interface IWebSocketPayloadCallEnded extends IWebSocketPayloadBase {
  callId: string;
}

/** In-app call session and websocket body for `INCOMING_CALL` (matches server notification). */
export interface IWebSocketPayloadIncomingCall {
  fromUserId: string;
  /** GraphQL `Call.createdUserId` — host / who started the call. */
  createdUserId: string;
  accessUserIdList: string[];
  isVideo: boolean;
  createTime: string;
  host: string;
  callId: string;
  token: string;
}
